// Shared image URLs and small data sources used across pages
export const IMAGES = {
    hero: "https://customer-assets.emergentagent.com/job_faith-fashion-gift/artifacts/kak758zt_IMG_8994.png",
    jewelry:
        "https://images.pexels.com/photos/33737462/pexels-photo-33737462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
    accessories:
        "https://images.pexels.com/photos/37546057/pexels-photo-37546057.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
    home_decor:
        "https://images.unsplash.com/photo-1762648603464-390cd0284e76?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    drinkware:
        "https://images.unsplash.com/photo-1729192293999-ffbdc97cbac9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    apparel:
        "https://images.pexels.com/photos/37186394/pexels-photo-37186394.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
    about_family:
        "https://images.pexels.com/photos/16760863/pexels-photo-16760863.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
    porch:
        "https://images.unsplash.com/photo-1721044060351-78b0a0c8b6e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};

export const CATEGORIES = [
    {
        slug: "jewelry",
        title: "Jewelry",
        image: IMAGES.jewelry,
        alt: "Turquoise western-style boutique jewelry on blush cushion",
    },
    {
        slug: "accessories",
        title: "Accessories",
        image: IMAGES.accessories,
        alt: "Cowboy hat with floral accents – western boutique accessory",
    },
    {
        slug: "home-decor",
        title: "Home Decor",
        image: IMAGES.home_decor,
        alt: "Faith-inspired Blessed home decor sign with florals",
    },
    {
        slug: "drinkware",
        title: "Drinkware",
        image: IMAGES.drinkware,
        alt: "Pink boutique tumbler with western cross design",
    },
    {
        slug: "apparel",
        title: "Apparel",
        image: IMAGES.apparel,
        alt: "Faith graphic t-shirt with western boots",
    },
];

export const FEATURES = [
    {
        key: "woman-owned",
        title: "Woman Owned",
        text: "Thank you for supporting a small business",
        icon: "Crown",
    },
    {
        key: "faith-based",
        title: "Faith Based",
        text: "We believe in blessings in every season",
        icon: "Cross",
    },
    {
        key: "porch-pickup",
        title: "Porch Pickup",
        text: "Fast, easy & convenient pickup at checkout",
        icon: "Truck",
    },
    {
        key: "made-with-love",
        title: "Made With Love",
        text: "Handpicked just for you",
        icon: "Heart",
    },
    {
        key: "premium-quality",
        title: "Premium Quality",
        text: "Beautiful items you'll love & cherish",
        icon: "BadgeCheck",
    },
];
